// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1OAuthIntrospectResponseSchema = z.object({
  active: z.boolean().describe("Boolean indicator if the token is active"),
  scope: z.coerce.string().describe("Space-separated list of scopes").nullish(),
  client_id: z.coerce.string().describe("Client identifier for the OAuth 2.0 client").nullish(),
  username: z.coerce.string().describe("Human-readable identifier for the resource owner").nullish(),
  token_type: z.coerce.string().describe("Type of the token").nullish(),
  exp: z.number().int().describe("Expiration timestamp (Unix timestamp)").nullish(),
  iat: z.number().int().describe("Token issued at timestamp (Unix timestamp)").nullish(),
  sub: z.coerce.string().describe("Subject of the token (usually user ID)").nullish(),
  aud: z.coerce.string().describe("Audience of the token").nullish(),
});
